import { FormLabel, FormControl } from '@mui/joy'
import { styled } from '@mui/joy/styles'
import CustomDatePickerControl from './CustomDatePickerControl'

// eslint-disable-next-line react/prop-types, no-unused-vars
const CustomDateRangePickerControl = ({ nameOne, nameTwo, label, formik, small = false, ...props }) => {
  return (
    <FormControl size={small ? 'sm' : 'md'}>
      {label && <FormLabel>{label}</FormLabel>}
      <FieldRangeWrapper small={small}>
        <CustomDatePickerControl name={nameOne} label="" formik={formik} {...props} />
        &#8211;
        <CustomDatePickerControl name={nameTwo} label="" formik={formik} {...props} />
      </FieldRangeWrapper>
    </FormControl>
  )
}

export default CustomDateRangePickerControl

const FieldRangeWrapper = styled('div')(({ theme }) => ({
  // height: '32px',
  // borderRadius: theme.vars.radius.sm,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  alignSelf: 'flex-start',
  // fontFamily: theme.vars.fontFamily.body,
  // fontSize: theme.vars.fontSize.xs,
  // fontWeight: theme.vars.fontWeight.md,
  // border: '1px solid',
  // borderColor: theme.vars.palette.neutral.outlinedBorder,
  // backgroundColor: theme.vars.palette.background.body,
  // boxShadow:
  //   'var(--joy-shadowRing, 0 0 #000),0px 1px 2px 0px rgba(var(--joy-shadowChannel, 21 21 21) / var(--joy-shadowOpacity, 0.08))',
  [theme.focus.selector]: theme.focus.default,
  ...theme.variants.plain.neutral,
  '.MuiFormControl-root': {},
  '.MuiFormLabel-root': { display: 'none' },
  '.MuiInput-root': {
    // border: 'none',
    // backgroundColor: 'transparent',
    // boxShadow: 'none',
    // minWidth: '0',
  },
  '.MuiInput-input': {
    maxWidth: '85px',
    flex: '1 1 80px',
  },
  '.MuiInputAdornment-root': {
    marginLeft: '0',
    svg: { fontSize: 20 },
    'button[title="Clear"]': { marginLeft: '-10px' },
  },
  '.MuiInput-startDecorator': { display: 'none' },
  '.MuiInput-endDecorator': { marginLeft: 0, marginRight: 3 },
}))
